import React, { useEffect, useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Menu,
    MenuItem,
    TablePagination,
} from '@mui/material';
import { Visibility, Edit, Delete } from '@mui/icons-material';
import { MdHistory, MdMoreHoriz } from 'react-icons/md';
import AddButton from '../../Common_Components/AddButton';
import { useNavigate, useParams } from 'react-router-dom';
import './UserList.css';
import axiosInstance from '../../axios/axios';
import { hasPrivilege } from '../UserRole/PrevilegeCheck';

const style = {
    fontFamily: 'Times New Roman',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '18.4px',
    color: '#000000',
    alignItems: 'center',
};

const actionStyles = {
    view: {
        color: '#72E463', // Customize the color of the text
        fontFamily: 'Josefin Sans, sans-serif', // Set the font family
        fontWeight: 400, // Set font weight
        textAlign: 'center', // Center text
        padding: '12px 12px', // Custom padding
        '& .MuiSvgIcon-root': {
            color: '#72E463', // Customize the color of the icon
        },
    },
    edit: {
        color: '#FFC575', // Customize the color of the text
        fontFamily: 'Josefin Sans, sans-serif', // Set the font family
        fontWeight: 400, // Set font weight
        textAlign: 'center', // Center text
        padding: '12px 12px', // Custom padding
        '& .MuiSvgIcon-root': {
            color: '#FFC575', // Customize the color of the icon
        },
    },
    delete: {
        color: '#FF7575', // Customize the color of the text
        fontFamily: 'Josefin Sans, sans-serif', // Set the font family
        fontWeight: 400, // Set font weight
        textAlign: 'center', // Center text 
        padding: '12px 12px', // Custom padding
        '& .MuiSvgIcon-root': {
            color: '#FF7575', // Customize the color of the icon
        },
    },
    history: {
        color: '#5C3685', // Customize the color of the text
        fontFamily: 'Josefin Sans, sans-serif', // Set the font family
        fontWeight: 400, // Set font weight
        textAlign: 'center', // Center text
        padding: '12px 12px', // Custom padding
        '& .MuiSvgIcon-root': {
            color: '#5C3685', // Customize the color of the icon
        },
    },
};


const UserList = () => {

    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const handleClick = (event, user) => {
        setAnchorEl(event.currentTarget);
        setSelectedUser(user); // Store the selected user
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const [users, setUsers] = useState([])
    useEffect(() => {
        const getUsers = async () => {
            const response = await axiosInstance.get('/users/listUsers')
            const { users, success } = response.data
            if (success === true) {
                setUsers(users)
            } else {
                setUsers([])
            }
        }
        getUsers()

    }, [])

    const handlenavigatetoAdd = async () => {
        navigate('/user/Add');
    };
    const handleEdit = async () => {
        navigate(`/user/Add/${selectedUser.UD_Id}`)
    }
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <div className="user-list">
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <h2 className='usertitle'>Users</h2>
                {
                    hasPrivilege('Add User') && <div style={{ display: 'flex', alignItems: 'center' }}>
                        <AddButton onClick={handlenavigatetoAdd} />
                    </div>
                }
            </div>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead style={{ backgroundColor: '#EEDEFF' }}>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 700, color: '#302D2D' }}>Name</TableCell>
                            <TableCell sx={{ fontWeight: 700, color: '#302D2D' }}>Email</TableCell>
                            <TableCell sx={{ fontWeight: 700, color: '#302D2D' }}>Address</TableCell>
                            <TableCell sx={{ fontWeight: 700, color: '#302D2D' }}>User Name</TableCell>
                            <TableCell sx={{ fontWeight: 700, color: '#302D2D' }}>Status</TableCell>
                            <TableCell sx={{ fontWeight: 700, color: '#302D2D' }}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {users && users.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((user, index) => (
                                <TableRow key={user.UD_Id} style={{ backgroundColor: index % 2 === 0 ? '#F6F6F6' : '#DAD9D9' }}>
                                    <TableCell sx={style}>{user.UD_Name}</TableCell>
                                    <TableCell sx={style}>{user.UD_Email}</TableCell>
                                    <TableCell sx={style}>{user.UD_Address}</TableCell>
                                    <TableCell sx={style}>{user.UD_userName}</TableCell>
                                    <TableCell sx={style}>{Number(user.UD_Status) === 1 ? 'Active' : "Inactive"}</TableCell>
                                    <TableCell>
                                        <MdMoreHoriz size={30} onClick={(event) => handleClick(event, user)} />
                                        <Menu
                                            id="action-menu"
                                            anchorEl={anchorEl}
                                            open={Boolean(anchorEl)}
                                            onClose={handleClose}
                                            sx={{
                                                '& .MuiMenuItem-root': {
                                                    minWidth: '200px',
                                                    borderBottom: '1px solid #e0e0e0',
                                                    '&:last-child': { borderBottom: 'none' },
                                                },
                                            }}
                                        >
                                            {/* <MenuItem onClick={() => console.log("View:", selectedUser)} sx={actionStyles.view}>
                                            <Visibility sx={{ mr: 1 }} /> View
                                        </MenuItem> */}
                                            {
                                                hasPrivilege('Edit User') && <MenuItem onClick={(e) => handleEdit(e)} sx={actionStyles.edit}>
                                                    <Edit sx={{ mr: 1 }} /> Edit
                                                </MenuItem>
                                            }
                                            {/* {
                                                hasPrivilege('Delete User') && <MenuItem onClick={() => console.log("Delete:", selectedUser)} sx={actionStyles.delete}>
                                                    <Delete sx={{ mr: 1 }} /> Delete
                                                </MenuItem>
                                            } */}

                                        </Menu>
                                    </TableCell>
                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 50]}
                    component="div"
                    count={users.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </TableContainer>
        </div>
    )
}

export default UserList